// The console's users (A19U3), owned by hand: the search in the address, as the route key's argument; read only
// behind `platform.org.support` (the layout lets in only staff).
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import { ConsoleUsers } from '../../features/platform/ConsoleUsers'
import { consoleUsersQuery } from '../../features/platform/queries'
import { text } from '../../shared/routing/search'
import '../../shared/shell/strings'

export const Route = createFileRoute('/platform/users')({
  staticData: { screenId: 'ConsoleUsersScreen', access: 'platform.org.support' },
  // The route key's query arguments (screens.json `args`), as the apps' LinkResolver reads them;
  // unknown keys are dropped.
  validateSearch: (search: Record<string, unknown>): { q?: string } => ({
    q: text(search.q),
  }),
  loaderDeps: ({ search }) => ({ q: search.q }),
  loader: ({ context: { queryClient }, deps }) => queryClient.ensureQueryData(consoleUsersQuery(deps.q)),
  component: ConsoleUsersScreen,
})

function ConsoleUsersScreen() {
  const { q } = Route.useLoaderDeps()
  const navigate = Route.useNavigate()
  const onSearch = useCallback(
    (next: string | undefined) => navigate({ search: { q: next }, replace: true }),
    [navigate],
  )
  const { t } = useTranslation()
  return (
    <main data-testid={ids.consoleUsers.root} className="flex flex-col gap-(--stack-lg)">
      <PageHeader title={t('shell.nav.users')} />
      <ConsoleUsers q={q} onSearch={onSearch} />
    </main>
  )
}
